import React from "react"
import { Helmet } from "react-helmet"
import { languages, defaultLanguage } from "../i18n/config"

// Map our URL codes to ISO 639-1 hreflang codes for SEO
const hreflangMap = {
  en: "en",
  es: "es",
  fr: "fr",
  de: "de",
  pt: "pt",
  br: "pt-BR",
  it: "it",
  th: "th",
  ua: "uk",
  by: "be",
  mt: "mt",
}

/**
 * Generates <link rel="alternate" hreflang="..."> tags for SEO.
 *
 * @param path - Path WITHOUT lang prefix (e.g. "/pricing/").
 * @param availableLocales - Locale codes that actually have a translated page
 *   at this path. When omitted, defaults to all configured languages (legacy
 *   behaviour - keep only for fully-translated pages). For en-only pages
 *   (blog, /privacy/, /terms/...) pass `["en"]` so Google doesn't get 404s.
 */
function HrefLangTags({ path, availableLocales }) {
  const siteUrl = "https://filmustage.com"
  const cleanPath = path || "/"
  const allowed = availableLocales
    ? new Set(availableLocales)
    : new Set(languages.map(l => l.code))

  return (
    <Helmet>
      {languages
        .filter(lang => allowed.has(lang.code))
        .map(lang => {
          const href =
            lang.code === defaultLanguage
              ? `${siteUrl}${cleanPath}`
              : `${siteUrl}/${lang.code}${cleanPath}`
          return (
            <link
              key={lang.code}
              rel="alternate"
              hrefLang={hreflangMap[lang.code] || lang.code}
              href={href}
            />
          )
        })}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${siteUrl}${cleanPath}`}
      />
    </Helmet>
  )
}

export default HrefLangTags
